<template>
  <div>
    <div v-if="lootEntry.isTemporary">
      <h3 class="pa-2">
        <v-icon class="mr-1">mdi-close-circle</v-icon>
        {{ $t('loot.no_details') }}
      </h3>
    </div>
    <div v-else>
      <v-tabs right v-model="tab">
        <v-tab key="details">Details</v-tab>
        <v-tab key="loot">{{ $t('char_detail.loot.title') }}</v-tab>
        <v-tab key="player-behaviour-log">{{ $t('behaviour_log.title') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="details">
          <v-list two-line>
            <v-list-item class="mt-2" :class="`${character.class.toLowerCase().replaceAll(' ', '-')}-bg`"
                         v-for="character of getSubEntries" :key="character.id">
              <class-avatar :size="40" :type="'class'" :value="character.class.toLowerCase()"
                            class="mr-3"></class-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <b :class="character.class.toLowerCase().replaceAll(' ', '-')">{{ character.name }}</b>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ character.state }} - {{ $t('loot.table.earliest_raid')}}: {{ character.earliestRaidDate}}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-row>
                  <h3 class="mt-1">{{ $t('loot.table.attendance') }} - {{ character.attendanceCount }} Raids
                    ({{ character.attendancePercent }} %)</h3>
                  <v-divider vertical class="mx-4"></v-divider>
                  <h3 class="mt-1 mr-4">Items - {{ character.itemsCount }}</h3>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
        <v-tab-item>
          <received-loot-table :items="lootEntry.items" :multi-character-view="true" :season-filter="false" :copied-items-filter="false"/>
        </v-tab-item>
        <v-tab-item key="player-behaviour-log">
          <player-behaviour-details :items="lootEntry.behaviourLogs" :multi-character-view="true" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import ClassAvatar from "@/components/ClassAvatar.vue";
import PlayerBehaviourDetails from "@/components/PlayerBehaviourDetails.vue";
import ReceivedLootTable from "@/components/ReceivedLootTable.vue";

export default {
  name: "LootDetailView",
  components: {ReceivedLootTable, PlayerBehaviourDetails, ClassAvatar},
  props: ["lootEntry", "difficulty"],
  data() {
    return {
      tab: 0,
      selectedCharacter: this.lootEntry,
      headers: [
        {text: '', value: "class", width: "20px", simple: true},
        {text: this.$t('general.misc.name'), value: "name", simple: true},
        {text: this.$t('loot.table.state'), value: "state", simple: true},
        {
          text: this.$t('loot.table.attendance'),
          value: "attendanceCount",
          align: 'center',
          simple: true
        },
        {
          text: this.$t('loot.table.attendance_percent'),
          value: "attendancePercent",
          align: 'center',
          simple: true
        },
        {
          text: this.$t('loot.table.items'),
          value: "itemsCount",
          align: 'center',
          simple: true
        }
      ]
    }
  },
  mounted() {
    this.selectedCharacter = this.lootEntry.subEntries.find(x => x.isMainEntry);
  },
  methods: {
    filterItemsOnDifficulty(items = []) {
      if (!this.difficulty) return items;
      return items.filter(it => it.difficulty === this.difficulty);
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters["auth/user"];
    },
    getSubEntries() {
      return (this.lootEntry.subEntries || []).map(ch => {
        const filtered = this.filterItemsOnDifficulty(ch.items || []);

        return {
          ...ch,
          itemsCount: filtered.length,
        };
      });
    }
  }
}
</script>


<style lang="scss">
.loot-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 15px;
}
</style>